var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.14764mm",
    height: "12.579304mm",
    viewBox: "0 0 11.14764 12.579304",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-400.05369,-233.21876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "translate(113.06228,50.111544)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.451826,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 248.89938,180.49625 -0.39125,2.67939 1.6518,1.19644 2.04917,-0.38523 0.88785,-1.93556 -0.83264,-1.79707 -1.80688,-0.76141 z",
    id: "path5-0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-5-0-8",
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.598173,
      paintOrder: "stroke fill markers"
    },
    d: "m 249.45829,179.30134 -0.834,0.61885 -0.73012,1.96042 0.2646,1.58885 1.71313,1.41391 1.89116,-0.30913 0.79753,1.14249 0.54838,0.99473 0.79875,-0.0743 0.55333,-0.96011 -1.61732,-1.73662 0.37282,-0.80183 0.30539,-1.71313 -0.77588,-1.17775 -1.49119,-0.9465 z m 1.32304,0.77833 1.21479,0.55827 0.49894,1.31685 -0.46555,1.47696 -1.57647,0.47665 -1.04973,-0.62998 -0.4557,-1.06399 0.47175,-1.57155 z m -1.22042,1.61048 0.005,0.63311 2.18235,0.0438 -0.0674,-0.65225 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/ZoomOut.5a29e6a3579058cc6101f6eb5a114f54.svg";
export { ForwardRef as ReactComponent };